// extracted by mini-css-extract-plugin
export default {"mensaje":"ValidationError_mensaje__v6crM"};